/**
 * loại chứng từ phía salagov
 */
export default {
  Salary: 1, // Rút lương
  BHXH: 2, // Nộp BHXH
  KPCD: 3, // Nộp KPCĐ
  Tax: 4, // Nộp thuế TNCN
};
